export const GET_LOT_DETAILS = '[lot] Get Details';
export const GET_BASIC_LOT_DETAILS = '[lot] Get Basic Lot Details';
export const FETCH_LOT_DETAILS_SUCCESS = '[lot] Fetch Success';
export const FETCH_LOT_DETAILS_ERROR = '[lot] Fetch Error';
export const FETCH_BASIC_LOT_DETAILS_SUCCESS = '[lot] Basic Fetch Success';
export const FETCH_BASIC_LOT_DETAILS_ERROR = '[lot] Basic Fetch Error';
export const SET_LOT_DETAILS = '[lot] Set Details';
export const CLEAR_LOT = '[lot] Clearing lot'
export const NOT_ME = '[Not Me] Request';
export const NOT_ME_SUCCESS = '[Not Me] Success';
export const NOT_ME_ERROR = '[Not Me] Error';
export const SET_TOTAL_STEPS = "[Lot] set total steps";

export const notMe = () => ({
  type: NOT_ME
});

export const getLotDetails = (id, postCode) => ({
  type: GET_LOT_DETAILS,
  payload: {id, postCode}
});

export const setTotalSteps = (number) => ({
  type: SET_TOTAL_STEPS,
  payload: number
});

export const setLotDetails = (data) => ({
  type: SET_LOT_DETAILS,
  payload: data
});

export const getBasicLotDetails = (id) => ({
  type: GET_BASIC_LOT_DETAILS,
  payload: {id}
});




// WEBPACK FOOTER //
// ./src/redux/actions/lot.js